<template>
  <v-dialog v-model="open" max-width="500px" persistent>
    <v-card flat>
      <v-card-title>
        <span>
          <v-icon class="icon">mdi-pencil</v-icon>
          {{ t(`editarContato`) }}
        </span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-if="cliente"
            prepend-icon="mdi-account"
            v-model="cliente.nome"
            :label="t(`nome`)"
          ></v-text-field>
          <v-select
            v-if="user.editaClienteGrupo"
            prepend-icon="mdi-account-group"
            v-model="cliente.nomeGrupo"
            :label="t(`grupo`)"
            :items="gruposNomes"
            required
            :rules="[(v) => !!v || 'Campo obrigatório']"
          ></v-select>
          <div v-if="user.editaCliente">
            <v-text-field
              prepend-icon="mdi-phone"
              v-model="cliente.numero"
              :label="t(`numero`)"
            ></v-text-field>
            <v-text-field
              prepend-icon="mdi-email"
              v-model="cliente.email"
              :label="t(`email`)"
            ></v-text-field>
            <v-text-field
              prepend-icon="mdi-link"
              v-model="cliente.url"
              :label="t(`url`)"
            ></v-text-field>

            <p>
              Campos Adicionais
              <v-btn
                icon
                @click="cliente.CamposAdicionais.push({ nome: ``, valor: `` })"
              >
                <v-icon>mdi-plus-box</v-icon>
              </v-btn>
            </p>
            <div
              v-if="
                cliente.CamposAdicionais && cliente.CamposAdicionais.length > 0
              "
            >
              <v-row
                v-for="(campo, index) in cliente.CamposAdicionais"
                :key="campo.id"
              >
                <v-col cols="6"
                  ><v-text-field
                    required
                    prepend-icon="mdi-information"
                    dense
                    :value="campo.nome"
                    v-model="cliente.CamposAdicionais[index].nome"
                    :rules="[(v) => !!v || 'Campo obrigatório']"
                  ></v-text-field
                ></v-col>
                <v-col cols="6">
                  <v-text-field
                    required
                    prepend-icon="mdi-information-variant"
                    dense
                    :value="campo.valor"
                    v-model="cliente.CamposAdicionais[index].valor"
                    :rules="[(v) => !!v || 'Campo obrigatório']"
                    append-icon="mdi-close"
                    @click:append="cliente.CamposAdicionais.splice(index, 1)"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
            <p>
              Numeros Adicionais
              <v-btn
                icon
                @click="
                  cliente.NumerosAdicionais.push({ nome: ``, numero: `` })
                "
              >
                <v-icon>mdi-plus-box</v-icon>
              </v-btn>
            </p>
            <div
              v-if="
                cliente.NumerosAdicionais &&
                cliente.NumerosAdicionais.length > 0
              "
            >
              <v-row
                v-for="(campo, index) in cliente.NumerosAdicionais"
                :key="campo.id"
              >
                <v-col cols="6"
                  ><v-text-field
                    prepend-icon="mdi-information"
                    dense
                    required
                    :value="campo.nome"
                    v-model="cliente.NumerosAdicionais[index].nome"
                    :rules="[(v) => !!v || 'Campo obrigatório']"
                  ></v-text-field
                ></v-col>
                <v-col cols="6">
                  <v-text-field
                    prepend-icon="mdi-information-variant"
                    dense
                    required
                    :value="campo.numero"
                    v-model="cliente.NumerosAdicionais[index].numero"
                    @click:append="cliente.NumerosAdicionais.splice(index, 1)"
                    append-icon="mdi-close"
                    :rules="[(v) => !!v || 'Campo obrigatório']"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="!cliente.nome || cliente.nome.length == 0"
          @click="editar()"
          color="primary"
          >{{ t(`editar`) }}</v-btn
        >
        <v-btn @click="cancelar()">{{ t(`cancelar`) }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
   
<script>
import { mapActions } from "vuex";
import { mapState } from "vuex";

export default {
  name: "Transferencia",
  props: {
    open: { type: Boolean, default: false },
    cliente: { type: Object, default: null },
    atendimento: { type: Object, default: null },
  },
  data() {
    return {
      files: [],
      nome: "",
      grupos: [],
      gruposNomes: [],
      valid: false,
    };
  },
  created() {},
  computed: {
    ...mapState("auth", {
      user: (state) => state.user,
    }),
    ...mapState("xc", {
      uploadStatus: (state) => state.uploadStatus,
    }),
  },
  watch: {
    open(nw) {
      if (nw) {
        this.getGrupos();
      }
    },
  },
  methods: {
    ...mapActions("xc", [
      "getDefault",
      "getClassificacoes",
      "setClassificacao",
      "setClassificacaoLigacao",
      "updateCliente",
      "updateAtendimento",
    ]),
    editar() {
      if (!this.$refs.form.validate()) return;
      if (this.cliente.nomeGrupo !== "Sem grupo") {
        this.cliente.idGrupo = this.grupos.find(
          (g) => g.nome === this.cliente.nomeGrupo
        ).id;
      } else {
        this.cliente.idGrupo = null;
      }
      let cliente = JSON.parse(JSON.stringify(this.cliente));
      delete cliente.nomeGrupo;
      this.updateCliente(cliente);
      this.atendimento.fromName = this.cliente.nome;
      this.updateAtendimento(this.atendimento);
      this.$emit("editar:open", false);
    },
    cancelar() {
      this.$emit("editar:open", false);
    },
    async getGrupos() {
      try {
        let grupos = await this.getDefault(
          "/api/v2/clientesGrupos?max=-1&page=1"
        );
        this.grupos = grupos;
        this.gruposNomes = grupos.map((g) => g.nome);
        this.gruposNomes.unshift("Sem grupo");
        if (this.cliente.idGrupo) {
          this.cliente.nomeGrupo = this.grupos.find(
            (g) => g.id == this.cliente.idGrupo
          ).nome;
        } else {
          this.cliente.nomeGrupo = "Sem grupo";
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
<style>
</style>